export default {
  state: {
    reasons: {
      // show: false,
      // message: '',
      list: [],
      unfiltered: [],
      unqualified: [],
      reasonsModal: false
    }
  },
  mutations: {
    setReasonsData (state, data) {
      for (let field in data) {
        state.reasons[field] = data[field]
        if (field === 'list') {
          state.reasons.list.sort((a, b) => a.name.localeCompare(b.name))
        }
      }
    },
    addReasonList (state, data) {
      state.reasons.list.push(data)
      state.reasons.list.sort((a, b) => a.name.localeCompare(b.name))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global/reasonModal.js